import { PlusOutlined } from '@ant-design/icons';
import { Button, List, Row } from 'antd';
import React, { useCallback, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { usePaginatedQuery } from 'react-query';

import { getTournaments } from 'api/events';
import EventCard from 'componentsv2/EventCard/EventCard';
import Empty from 'componentsv2/Empty/Empty';
import BlockPageLoader from 'components/Loaders/BlockPageLoader';
import { paths } from 'configs/paths';

const Events = () => {
  const [page, setPage] = useState(1);
  const gridConfig = { gutter: 48, xs: 1, sm: 1, md: 2, lg: 3, xl: 3, xxl: 3 };

  const resolver = useCallback(async () => {
    const { body } = await getTournaments(page);
    return {
      data: body?.data?.tournaments || [],
      hasMore: Boolean(body?.pagination?.next) || false,
      total: body?.pagination?.count,
    };
  }, [page]);

  const { status, resolvedData } = usePaginatedQuery(['events', page], resolver);

  const events = useMemo(() => resolvedData?.data || [] || [], [resolvedData]);

  const paginationConfig = {
    hideOnSinglePage: true,
    total: resolvedData?.total,
    showSizeChanger: false,
    defaultPageSize: 9,
    onChange: page => setPage(page),
  };

  const isLoading = useMemo(() => status === 'loading', [status]);

  const renderListItem = event => (
    <List.Item>
      <EventCard key={event?.tournament?.id} event={event?.tournament} />
    </List.Item>
  );

  return (
    <>
      <Row align="middle" justify="end" className="mb-4">
        <Link to={paths.dashboard.newEvent}>
          <Button type="primary" icon={<PlusOutlined />} className="btn--icon" loading={isLoading}>
            Agregar Evento
          </Button>
        </Link>
      </Row>
      {isLoading && <BlockPageLoader className="min-h-screen" valignTop />}
      {!isLoading && (
        <List
          dataSource={events}
          grid={gridConfig}
          locale={{
            emptyText: <Empty />,
          }}
          pagination={paginationConfig}
          renderItem={renderListItem}
        />
      )}
    </>
  );
};

export default Events;
